// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightLanding-cls1_WGJ","cls2":"CiterightLanding-cls2_cPB CiterightLanding-cls1_WGJ"};